import { jsx as t, jsxs as d, Fragment as w } from "react/jsx-runtime";
import { withManagedProps as A } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as v } from "@made-people/react-prop-guard";
import { logoBlueprint as ve, menuTriggerBlueprint as ye, cartTriggerBlueprint as Se, accountTriggerBlueprint as Ce, template1Styling as R, searchTriggerBlueprint as Ne, template2Styling as x, template3Styling as j, template4Styling as H, bareboneBlueprint as q } from "./index-blueprint.es.js";
import { TRYLogo as ke, BurgerIcon as Ie, CartIcon as we, UserIcon as xe, MagnifierIcon as je, CrossIcon as Le } from "@made-people/blueprint-icons";
import { useLink as Z, useNavigate as Ae } from "@made-people/grease-link";
import I from "clsx";
import { buttonContentPropsSchema as J, Button as U } from "@made-people/blueprint-button";
import { overlayEventEmitter as D } from "@made-people/blueprint-overlay";
import { useMemo as $, useState as L, useEffect as X, useRef as Pe, useCallback as se } from "react";
import { useCartState as Be } from "@made-people/grease-cart";
import { motion as ge, AnimatePresence as Ee } from "motion/react";
import { stickyWrapperSchema as O, StickyWrapper as Q } from "@made-people/blueprint-sticky-wrapper";
import { searchInputSchema as de, SearchInput as be } from "@made-people/blueprint-search";
import { siteSettingsTriggerSchema as ee, SiteSettingsTrigger as te } from "@made-people/blueprint-site-settings";
import "@made-people/blueprint";
const P = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  svg: e.custom().optional(),
  className: e.string().optional()
}), F = v(
  {
    schema: P,
    defaultProps: {
      enabled: !0,
      svg: /* @__PURE__ */ t(ke, {})
    }
  },
  ({ blueprint: i, variants: r, svg: u, enabled: g, className: o }) => {
    const n = Z(), c = (i ?? ve).styles(r);
    return g ? /* @__PURE__ */ t("div", { className: I(c.wrapper, o), children: /* @__PURE__ */ t(n, { className: c.link, href: "", "aria-label": "Go to home", children: u }) }) : null;
  }
), K = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  overlayId: e.string().optional(),
  className: e.string().optional()
}), ne = v(
  {
    schema: K,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Menu"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(Ie, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: i, variants: r, enabled: u, className: g, ...o }) => {
    var c, l, b, s, m, h;
    const a = (i ?? ye).styles(r);
    return u === !1 ? null : /* @__PURE__ */ d(
      "div",
      {
        className: I(a.wrapper, g),
        onClick: () => D.emit("open", {
          overlayId: o.overlayId
        }),
        children: [
          !((c = o.button) != null && c.enabled) && /* @__PURE__ */ d(w, { children: [
            ((l = o.icon) == null ? void 0 : l.enabled) && /* @__PURE__ */ t("span", { className: a.icon, children: o.icon.iconSvg }),
            ((b = o.label) == null ? void 0 : b.enabled) && /* @__PURE__ */ t("span", { className: a.label, children: o.label.labelText })
          ] }),
          ((s = o.button) == null ? void 0 : s.enabled) && /* @__PURE__ */ t(
            U,
            {
              as: "span",
              label: ((m = o.label) == null ? void 0 : m.enabled) && o.label.labelText,
              iconLeft: ((h = o.icon) == null ? void 0 : h.enabled) && o.icon.iconSvg,
              ...o.button.settings
            }
          )
        ]
      }
    );
  }
), B = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  qtyDisplay: e.enum(["total_quantity", "total_items"]).optional(),
  animateQtyOnUpdate: e.boolean().optional(),
  type: e.enum(["mini-cart", "link-to-checkout"]).optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional()
}), G = v(
  {
    schema: B,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Cart"
      },
      type: "link-to-checkout",
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(we, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: i, variants: r, enabled: u, type: g, className: o, ...n }) => {
    var k;
    const c = (i ?? Se).styles(r), { cart: l } = Be(), b = Z(), s = $(() => n.qtyDisplay === "total_items" ? l == null ? void 0 : l.items.length : l == null ? void 0 : l.items.reduce((T, p) => T + p.quantity, 0), [l, n.qtyDisplay]), [m, h] = L(s), [f, S] = L(!1);
    X(() => {
      if (m !== null && s !== m && n.animateQtyOnUpdate) {
        S(!0);
        const T = setTimeout(() => S(!1), 500);
        return h(s), () => clearTimeout(T);
      }
    }, [s]);
    const C = $(
      () => {
        var T, p, y;
        return /* @__PURE__ */ t(
          U,
          {
            as: g === "link-to-checkout" ? "a" : "button",
            link: g === "link-to-checkout" ? { href: "checkout" } : void 0,
            onClick: g === "mini-cart" ? () => D.emit("open", { overlayId: "mini-cart" }) : void 0,
            iconLeft: ((T = n.icon) == null ? void 0 : T.enabled) && n.icon.iconSvg,
            iconRight: /* @__PURE__ */ t(
              ce,
              {
                qty: s,
                className: c.counter,
                shouldAnimate: f
              }
            ),
            label: ((p = n.label) == null ? void 0 : p.enabled) && n.label.labelText,
            ...(y = n == null ? void 0 : n.button) == null ? void 0 : y.settings,
            className: o
          }
        );
      },
      [g, n.icon, n.label, c.counter, s, f]
    ), N = $(() => {
      var p, y;
      const T = /* @__PURE__ */ d(w, { children: [
        ((p = n.icon) == null ? void 0 : p.enabled) && /* @__PURE__ */ t("span", { className: c.icon, children: n.icon.iconSvg }),
        ((y = n.label) == null ? void 0 : y.enabled) && /* @__PURE__ */ t("span", { className: c.label, children: n.label.labelText }),
        /* @__PURE__ */ t(
          ce,
          {
            qty: s,
            className: c.counter,
            shouldAnimate: f
          }
        )
      ] });
      return g === "link-to-checkout" ? /* @__PURE__ */ t(
        b,
        {
          href: "checkout",
          className: I(c.wrapper, o),
          "aria-label": "Go to checkout",
          children: T
        }
      ) : /* @__PURE__ */ t(
        "button",
        {
          className: I(c.wrapper, o),
          onClick: () => D.emit("open", { overlayId: "mini-cart" }),
          children: T
        }
      );
    }, [g, n.icon, n.label, c, s, f]);
    return u ? (k = n.button) != null && k.enabled ? C : N : null;
  }
), ce = ({
  qty: i,
  className: r,
  shouldAnimate: u
}) => /* @__PURE__ */ t(
  ge.span,
  {
    className: r,
    animate: u ? { scale: [1, 0.9, 1.2, 0.8, 1] } : { scale: 1 },
    transition: {
      duration: 0.4,
      ease: "easeOut"
      // times: [0, 0.2, 0.6, 0.8, 1], // Custom timing for each keyframe
    },
    children: i
  }
), E = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  onClick: e.custom().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional(),
  href: e.string().optional(),
  action: e.enum(["drawer", "page"]).optional(),
  loggedIn: e.object({
    isLoggedIn: e.boolean().optional(),
    showInitials: e.boolean().optional(),
    label: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional()
  }).optional()
}), W = v(
  {
    schema: E,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "My Account"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(xe, {})
      },
      button: {
        enabled: !1
      },
      loggedIn: {
        isLoggedIn: !1,
        showInitials: !0
      }
    }
  },
  ({ blueprint: i, variants: r, enabled: u, className: g, href: o, onClick: n, ...a }) => {
    var S, C, N, k, T, p, y, M, ae, le, ie, oe, re;
    const l = (i ?? Ce).styles(r), b = Ae();
    if (u === !1 || o === void 0 && a.action !== "drawer")
      return null;
    const s = Z(), m = (S = a.loggedIn) != null && S.showInitials ? Me(a.loggedIn.firstName, a.loggedIn.lastName) : "", h = a.action === "drawer" ? "button" : s, f = () => {
      a.action === "drawer" ? D.emit("open", { overlayId: "login-drawer" }) : b(o ?? "");
    };
    return /* @__PURE__ */ d(w, { children: [
      !((C = a.loggedIn) != null && C.isLoggedIn) && /* @__PURE__ */ d("div", { className: I(l.wrapper, g), children: [
        !((N = a.button) != null && N.enabled) && /* @__PURE__ */ d(
          h,
          {
            href: o ?? "",
            "aria-label": "Go to account",
            onClick: f,
            children: [
              ((k = a.icon) == null ? void 0 : k.enabled) && /* @__PURE__ */ t("span", { className: l.icon, children: a.icon.iconSvg }),
              ((T = a.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: l.label, children: a.label.labelText })
            ]
          }
        ),
        ((p = a.button) == null ? void 0 : p.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "button",
            onClick: f,
            iconLeft: ((y = a.icon) == null ? void 0 : y.enabled) && a.icon.iconSvg,
            label: ((M = a.label) == null ? void 0 : M.enabled) && a.label.labelText,
            ...a.button.settings
          }
        )
      ] }),
      ((ae = a.loggedIn) == null ? void 0 : ae.isLoggedIn) && /* @__PURE__ */ d("div", { className: I(l.wrapper, g), children: [
        !((le = a.button) != null && le.enabled) && /* @__PURE__ */ d(s, { href: o ?? "", children: [
          ((ie = a.icon) == null ? void 0 : ie.enabled) && /* @__PURE__ */ t("span", { className: l.icon, children: /* @__PURE__ */ t("span", { className: l.loggedInInitials, children: m }) }),
          a.loggedIn.label && /* @__PURE__ */ t("span", { className: l.label, children: a.loggedIn.label })
        ] }),
        ((oe = a.button) == null ? void 0 : oe.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "a",
            link: { href: o },
            iconLeft: ((re = a.icon) == null ? void 0 : re.enabled) && /* @__PURE__ */ t("span", { className: l.loggedInInitials, children: m }),
            label: a.loggedIn.label && a.loggedIn.label,
            ...a.button.settings
          }
        )
      ] })
    ] });
  }
);
function Me(i, r) {
  const u = (i == null ? void 0 : i[0]) ?? "", g = (r == null ? void 0 : r[0]) ?? "";
  return `${u}${g}`.toUpperCase();
}
const Y = e.union([
  e.literal("mobile"),
  e.literal("tablet"),
  e.literal("desktop"),
  e.literal("none"),
  e.array(e.enum(["mobile", "tablet", "desktop"]))
]).optional();
function _(i) {
  const r = {
    "data-screen-mobile": "hidden",
    "data-screen-tablet": "hidden",
    "data-screen-desktop": "hidden"
  };
  return i ? (Array.isArray(i) ? i : [i]).forEach((g) => {
    g === "mobile" ? r["data-screen-mobile"] = "visible" : g === "tablet" ? r["data-screen-tablet"] = "visible" : g === "desktop" && (r["data-screen-desktop"] = "visible");
  }) : (r["data-screen-mobile"] = "visible", r["data-screen-tablet"] = "visible", r["data-screen-desktop"] = "visible"), r;
}
const ue = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search
   */
  search: de.optional().describe("Configure the Search"),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  stickyType: O.shape.type.optional()
}), Re = A(
  "HeaderTemplate1",
  v(
    ue,
    ({
      variants: i,
      cartTrigger: r,
      menuTrigger: u,
      accountTrigger: g,
      menu: o,
      topbar: n,
      stickyType: a,
      ...c
    }) => {
      const l = R.main.styles(i);
      return /* @__PURE__ */ d(
        Q,
        {
          className: l.wrapper,
          type: a,
          ..._(c == null ? void 0 : c.visibility),
          children: [
            n && n,
            /* @__PURE__ */ d("div", { className: l.nav, children: [
              /* @__PURE__ */ d("div", { className: l.left, children: [
                /* @__PURE__ */ t(
                  ne,
                  {
                    ...u,
                    blueprint: R.menuTrigger
                  }
                ),
                o && o,
                /* @__PURE__ */ t("div", { className: l.search, children: /* @__PURE__ */ t(be, { ...c.search }) })
              ] }),
              /* @__PURE__ */ t("div", { className: l.center, children: /* @__PURE__ */ t(F, { ...c.logo, blueprint: R.logo }) }),
              /* @__PURE__ */ d("div", { className: l.right, children: [
                /* @__PURE__ */ t(
                  W,
                  {
                    ...g,
                    blueprint: R.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...r,
                    blueprint: R.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), z = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  /**
   * @property {string} [searchRoute] - An optional string representing the search route.
   */
  searchRoute: e.string().optional(),
  onStateChange: e.custom().optional(),
  icons: e.object({
    default: e.custom().or(e.literal(!1)).optional(),
    close: e.custom().or(e.literal(!1)).optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional()
}), V = v(
  {
    schema: z,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Search"
      },
      icons: {
        default: /* @__PURE__ */ t(je, {}),
        close: /* @__PURE__ */ t(Le, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: i, variants: r, enabled: u, className: g, onStateChange: o, ...n }) => {
    var S, C;
    const c = (i ?? Ne).styles(r), l = Z(), [b, s] = L(!1), m = b ? (S = n == null ? void 0 : n.icons) == null ? void 0 : S.close : (C = n == null ? void 0 : n.icons) == null ? void 0 : C.default;
    if (u === !1)
      return null;
    const h = () => {
      D.emit("open", { overlayId: "search-sidebar" });
    }, f = () => {
      var N, k, T, p, y, M;
      return /* @__PURE__ */ d(w, { children: [
        !((N = n.button) != null && N.enabled) && /* @__PURE__ */ d(w, { children: [
          ((k = n.icons) == null ? void 0 : k.default) && /* @__PURE__ */ t("span", { className: c.icon, children: m }),
          ((T = n.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: c.label, children: n.label.labelText })
        ] }),
        ((p = n.button) == null ? void 0 : p.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "span",
            label: ((y = n.label) == null ? void 0 : y.enabled) && n.label.labelText,
            iconLeft: ((M = n.icons) == null ? void 0 : M.default) && m,
            ...n.button.settings
          }
        )
      ] });
    };
    return /* @__PURE__ */ d(w, { children: [
      n.searchRoute && /* @__PURE__ */ t(
        l,
        {
          href: n.searchRoute,
          className: I(c.wrapper, g),
          children: f()
        }
      ),
      !n.searchRoute && /* @__PURE__ */ t(
        "span",
        {
          className: I(c.wrapper, g),
          onClick: h,
          children: f()
        }
      )
    ] });
  }
), me = e.object({
  variants: e.custom().optional(),
  logo: P.optional().describe("Configure the Logo"),
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  siteSettingsTrigger: ee.optional(),
  visibility: Y,
  menu: e.custom().optional(),
  topbar: e.custom().optional(),
  stickyType: O.shape.type.optional()
}), He = A(
  "HeaderTemplate2",
  v(
    {
      schema: me,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: i,
      cartTrigger: r,
      menuTrigger: u,
      accountTrigger: g,
      searchTrigger: o,
      siteSettingsTrigger: n,
      menu: a,
      topbar: c,
      stickyType: l,
      ...b
    }) => {
      const s = x.main.styles(i), [m, h] = L(!1), f = Pe(null), S = $(
        () => ({
          // Remove dynamic height calculations - let CSS handle it
          overflow: "hidden"
        }),
        []
      ), C = se((N) => {
        requestAnimationFrame(() => {
          h(N);
        });
      }, []);
      return /* @__PURE__ */ t(w, { children: /* @__PURE__ */ d(
        Q,
        {
          forwardedRef: f,
          className: s.wrapper,
          type: l,
          ..._(b == null ? void 0 : b.visibility),
          style: S,
          children: [
            c && c,
            /* @__PURE__ */ d("div", { className: s.nav, children: [
              /* @__PURE__ */ d("div", { className: s.left, children: [
                /* @__PURE__ */ t(
                  ne,
                  {
                    ...u,
                    blueprint: x.menuTrigger
                  }
                ),
                a && a,
                /* @__PURE__ */ t(
                  V,
                  {
                    ...o,
                    blueprint: x.searchTrigger,
                    onStateChange: C
                  }
                )
              ] }),
              /* @__PURE__ */ t("div", { className: s.center, children: /* @__PURE__ */ t(F, { ...b.logo, blueprint: x.logo }) }),
              /* @__PURE__ */ d("div", { className: s.right, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...n,
                    className: s.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  W,
                  {
                    ...g,
                    blueprint: x.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...r,
                    blueprint: x.cartTrigger
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ t(Ee, { mode: "wait", children: m && /* @__PURE__ */ t(
              ge.div,
              {
                className: "w-full z-30 px-component-spacing-sm pb-3",
                initial: { height: 0, opacity: 0 },
                animate: {
                  height: "auto",
                  opacity: 1,
                  transition: {
                    height: { duration: 0.3, ease: [0.19, 1, 0.22, 1] },
                    opacity: { duration: 0.2, delay: 0.1 }
                  }
                },
                exit: {
                  height: 0,
                  opacity: 0,
                  transition: {
                    height: { duration: 0.2, ease: "easeOut" },
                    opacity: { duration: 0.15 }
                  }
                },
                style: { overflow: "hidden" },
                children: /* @__PURE__ */ t(
                  be,
                  {
                    autoComplete: { enabled: !0 },
                    autoFocus: !0
                  }
                )
              }
            ) })
          ]
        }
      ) });
    }
  )
), he = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  /**
   * Configure the Menu Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  stickyType: O.shape.type.optional()
}), qe = A(
  "HeaderTemplate3",
  v(
    he,
    ({
      variants: i,
      cartTrigger: r,
      menuTrigger: u,
      accountTrigger: g,
      searchTrigger: o,
      menu: n,
      topbar: a,
      stickyType: c,
      ...l
    }) => {
      const b = j.main.styles(i);
      return /* @__PURE__ */ d(
        Q,
        {
          className: b.wrapper,
          type: c,
          ..._(l == null ? void 0 : l.visibility),
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: b.nav, children: [
              /* @__PURE__ */ t("div", { className: b.left, children: /* @__PURE__ */ t(F, { ...l.logo, blueprint: j.logo }) }),
              /* @__PURE__ */ d("div", { className: b.right, children: [
                /* @__PURE__ */ t(
                  V,
                  {
                    ...o,
                    blueprint: j.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  W,
                  {
                    ...g,
                    blueprint: j.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...r,
                    blueprint: j.cartTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  ne,
                  {
                    ...u,
                    blueprint: j.menuTrigger
                  }
                ),
                n && n
              ] })
            ] })
          ]
        }
      );
    }
  )
), fe = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Country Selector
   */
  siteSettingsTrigger: ee.optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  stickyType: O.shape.type.optional()
}), Ue = A(
  "HeaderTemplate4",
  v(
    {
      schema: fe,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: i,
      cartTrigger: r,
      searchTrigger: u,
      accountTrigger: g,
      siteSettingsTrigger: o,
      menu: n,
      topbar: a,
      stickyType: c,
      ...l
    }) => {
      const [b, s] = L(!1), m = se(() => {
        s(window.scrollY > 100);
      }, []);
      X(() => (window.addEventListener("scroll", m), () => {
        window.removeEventListener("scroll", m);
      }), []);
      const h = H.main.styles(i);
      return /* @__PURE__ */ d(
        Q,
        {
          className: h.wrapper,
          type: c,
          ..._(l == null ? void 0 : l.visibility),
          "data-scrolled": b,
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: h.nav, children: [
              /* @__PURE__ */ d("div", { className: h.left, children: [
                /* @__PURE__ */ t(F, { ...l.logo, blueprint: H.logo }),
                n && n
              ] }),
              /* @__PURE__ */ d("div", { className: h.right, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...o,
                    className: h.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  V,
                  {
                    ...u,
                    blueprint: H.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  W,
                  {
                    ...g,
                    blueprint: H.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...r,
                    blueprint: H.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), Te = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  siteSettingsTrigger: ee.optional(),
  stickyType: O.shape.type.optional(),
  search: de.optional().describe("Configure the Search")
}), De = A(
  "HeaderBarebone",
  v(
    {
      schema: Te,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: i,
      cartTrigger: r,
      searchTrigger: u,
      accountTrigger: g,
      siteSettingsTrigger: o,
      menu: n,
      topbar: a,
      stickyType: c,
      search: l,
      ...b
    }) => {
      const s = q.main.styles(i), [m, h] = L(!1);
      return X(() => {
        const f = () => {
          h(window.scrollY > 100);
        };
        return window.addEventListener("scroll", f), () => {
          window.removeEventListener("scroll", f);
        };
      }, []), /* @__PURE__ */ d(
        Q,
        {
          className: s.wrapper,
          type: c,
          ..._(b == null ? void 0 : b.visibility),
          "data-scrolled": m,
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: s.nav, children: [
              /* @__PURE__ */ t(
                F,
                {
                  ...b.logo,
                  blueprint: q.logo,
                  className: s.logoPosition
                }
              ),
              n && /* @__PURE__ */ t("div", { className: s.menuPosition, children: n }),
              /* @__PURE__ */ t(
                te,
                {
                  ...o,
                  className: s.siteSettingsTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                V,
                {
                  ...u,
                  blueprint: q.searchTrigger,
                  className: s.searchTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                W,
                {
                  ...g,
                  blueprint: q.accountTrigger,
                  className: s.accountTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                G,
                {
                  ...r,
                  blueprint: q.cartTrigger,
                  className: s.cartTriggerPosition
                }
              )
            ] })
          ]
        }
      );
    }
  )
), pe = e.discriminatedUnion("template", [
  ue.extend({
    template: e.literal("template1")
  }),
  me.extend({
    template: e.literal("template2")
  }),
  he.extend({
    template: e.literal("template3")
  }),
  fe.extend({
    template: e.literal("template4")
  }),
  Te.extend({
    template: e.literal("barebone")
  })
]), Oe = v(pe, (i) => {
  switch (i.template) {
    case "template1":
      return /* @__PURE__ */ t(Re, { ...i });
    case "template2":
      return /* @__PURE__ */ t(He, { ...i });
    case "template3":
      return /* @__PURE__ */ t(qe, { ...i });
    case "template4":
      return /* @__PURE__ */ t(Ue, { ...i });
    case "barebone":
      return /* @__PURE__ */ t(De, { ...i });
    default:
      return null;
  }
}), Qe = "template2", Fe = e.object({
  settings: pe.optional()
}), ot = A(
  "Header",
  v({ schema: Fe, defaultProps: {} }, (i) => {
    const r = i.settings || { template: Qe };
    return /* @__PURE__ */ t(Oe, { ...r });
  })
);
export {
  W as AccountTrigger,
  G as CartTrigger,
  ot as Header,
  De as HeaderBarebone,
  F as Logo,
  ne as MenuTrigger,
  V as SearchTrigger,
  Oe as SelectTemplate,
  Re as Template1,
  He as Template2,
  qe as Template3,
  Ue as Template4,
  E as accountTriggerSchema,
  Te as bareboneSchema,
  Y as breakpointsSchema,
  B as cartTriggerSchema,
  Fe as headerPropsSchema,
  pe as headerSchema,
  P as logoSchema,
  K as menuTriggerSchema,
  z as searchTriggerSchema,
  _ as setBreakpointDataAttributes,
  ue as template1Schema,
  me as template2Schema,
  he as template3Schema,
  fe as template4Schema
};
//# sourceMappingURL=index.es.js.map
